import PropTypes from "prop-types";

// personal-data
const user = PropTypes.shape({
  email: PropTypes.string,
  firstName: PropTypes.string,
  gender: PropTypes.string,
  age: PropTypes.number,
});

const partner = PropTypes.shape({
  email: PropTypes.string,
  firstName: PropTypes.string,
  gender: PropTypes.string,
  id: PropTypes.number,
  birthday: PropTypes.string,
});

const answer = PropTypes.shape({
  answer: PropTypes.number,
  createdAt: PropTypes.string,
  gameId: PropTypes.number,
  id: PropTypes.number,
  questionId: PropTypes.number,
  status: PropTypes.any, // TODO define type
  updatedAt: PropTypes.string,
  userId: PropTypes.number,
});

const link = PropTypes.shape({
  id: PropTypes.number,
  link: PropTypes.string,
});

const game = PropTypes.shape({
  answers: PropTypes.arrayOf(answer),
  id: PropTypes.number,
  invitedUserId: PropTypes.number,
  link: link,
  linkId: PropTypes.number,
  name: PropTypes.string,
  partner: PropTypes.oneOfType([partner, PropTypes.array]),
  status: PropTypes.any,
  userId: PropTypes.number,
});
// personal-data

// in-game
const compromiseAnswer = PropTypes.shape({
  answer: PropTypes.number,
  gameId: PropTypes.number,
  id: PropTypes.number,
  questionId: PropTypes.number,
  status: PropTypes.any,
  userId: PropTypes.number,
});

const gameCard = PropTypes.shape({
  cardUrl: PropTypes.string,
  id: PropTypes.number,
  name: PropTypes.string,
  question: PropTypes.string,
});

const compromiseGameCard = PropTypes.shape({
  cardUrl: PropTypes.string,
  id: PropTypes.number,
  name: PropTypes.string,
  question_for_female: PropTypes.string,
  question_for_male: PropTypes.string,
  answer: compromiseAnswer,
  partnerAnswer: compromiseAnswer,
});
// in-game

// game-matches

const gameMatch = PropTypes.shape({
  answer: PropTypes.number,
  cardUrl: PropTypes.string,
  gameId: PropTypes.number,
  id: PropTypes.number,
  newMatch: PropTypes.bool,
  question: PropTypes.string,
  questionId: PropTypes.number,
  status: PropTypes.any,
  userId: PropTypes.number,
});

const gameTestResult = PropTypes.shape({
  answer: PropTypes.number,
  cardUrl: PropTypes.string,
  gameId: PropTypes.number,
  id: PropTypes.number,
  newMatch: PropTypes.bool,
  question: PropTypes.string,
  questionId: PropTypes.number,
  status: PropTypes.any,
  userId: PropTypes.number,
  isCheckedZone: PropTypes.bool,
});

const marathonCard = PropTypes.shape({
  cardUrl: PropTypes.string,
  createdAt: PropTypes.string,
  id: PropTypes.number,
  name: PropTypes.string,
  question_for_female: PropTypes.string,
  question_for_male: PropTypes.string,
  updatedAt: PropTypes.string,
});

const gameMatches = PropTypes.arrayOf(gameMatch);

// game-matches

// general

const typeSpinner = PropTypes.oneOf(["default", "light"]);

// general

export default {
  user,
  game,
  typeSpinner,
  gameCard,
  compromiseGameCard,
  gameMatches,
  gameMatch,
  marathonCard,
  gameTestResult,
};
